<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Compose message</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickDiscardChanges"
                >
                    Discard
                </v-btn>

                <v-btn
                    dark
                    text
                    @click="onClickSave"
                    :disabled="!valid"
                >
                    {{confirm_text}}
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

            <v-form
                v-model="valid"
            >
                <m-text-field
                    autofocus
                    :hint=hint
                    v-model="message"
                    :rules="rules"
                    emoji
                />

                <v-chip
                    color="primary"
                    class="ma-2"
                    label
                    small
                    v-if="show_message_type"
                    style="position: relative; left: -7px;"
                >
                    {{message_type}}
                </v-chip>
                
            </v-form>


            <v-chip
                v-for="(item, index) in insert_chips"
                :key="index"
                style="margin-right: 8px;"
                v-on:click="onClickInsertChip(item)"
            >
                {{item.text}}
            </v-chip>

            <div
                style="text-align: right"
            >
                <v-btn
                    color="primary"
                    style="margin-top: 15px"
                    v-on:click="onClickSave"
                    :disabled="!valid"
                >
                    {{confirm_text}}
                </v-btn>
            </div>

        </v-card-text>

    </v-card> 

</v-dialog>
</template>

<script>

export default {
    props: {
        hint : {
            type: String,
            default: function() { return "Type or copy/paste your message here.  Use enter to add newlines.  Field will auto-grow to contain your content."; }
        },

        confirm_text : {
            type: String,
            default: function() { return "SEND"; }
        },

        rules: {
            type: Array,
            default: function () { return []; },
        },

        show_message_type: {
            type: Boolean,
            default: function () { return false; }
        },

        force_mms: {
            type: Boolean,
            default: function () { return false; }
        },

        insert_chips: {
            type: Array,
            default: function() { return []; }
        },
    },

    data() {
        return {
            dialog: false,
            is_valid: true,
            message: '',
            valid: false,
        }
    },

    methods: {

        showDialog(message)
        {
            if ( message != null )
            {
                this.message = message.trim();
            }
            else
            {
                this.message = '';
            }

            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            // The dialog is showing...
            if ( this.is_valid )
            {
                this.dialog = false;
                next(false);
                return;
            }
        
            this.$rc.snackbar('You must either correct the errors or discard your changes.',1500);
            this.dialog = true;
            next(false);
        },

        onClickSave()
        {
            this.save();
            this.closeDialog();
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        save()
        {
            this.$emit('ok',this.message);
        },

        onClickInsertChip(item)
        {
            if ( this.message.length > 0 && this.message.charAt(this.message.length-1) != ' ') 
                this.message += ' ';
                
            this.message += item.value;
        },
    },

    computed: {
        picker_style()
        {
            return { position: 'fixed', top: '75px', right: '25px', 'z-index': '1' };
        },

        message_type() 
        {
            if ( this.force_mms )
                return 'MMS';

            return this.$rc.messageType(this.message);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>